export const quantiyPackApiNameToQuantityNameMap = {
  'additional-marketing-contacts': 'CONTACTS',
  'additional-sales-seats': 'SALES_SEAT',
  'additional-service-seats': 'SERVICE_SEAT',
  'additional-commerce-seats': 'COMMERCE_SEAT',
  'additional-legacy-contacts': 'CONTACTS',
  'default-quantity-pack': 'CORE_SEAT'
};